module.exports = __webpack_public_path__ + "static/media/motorhome_salmon.c7acffd8.svg";